import { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import FooterSection from './components/FooterSection';
import CustomCursor from './components/CustomCursor';
import useScrollAnimation from './hooks/useScrollAnimation';
import { useSmoothScroll } from './hooks/useSmoothScroll';

// Import the new page components
import Home from './pages/Home';
import Background from './pages/Background';
import Work from './pages/Work';


function App() {
  // Apply scroll animation effect to elements with animate-on-scroll class
  useScrollAnimation();
  
  // Apply smooth scrolling
  useSmoothScroll();

  // Update document title
  useEffect(() => {
    document.title = 'Manish Portfolio';
  }, []);

  return (
    <Router>
      <div className="relative">
        <CustomCursor />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/background" element={<Background />} />
          <Route path="/work" element={<Work />} />
    
         
        </Routes>
        <FooterSection />
      </div>
    </Router>
  );
}

export default App;